import dishEditor from '@/AppAdmin/views/DishEditor/translations';
import userEditor from '@/AppAdmin/views/UserEditor/translations';

import en from './en.json';
import vi from './vi.json';

export default {
  en: {
    ...en,
    ...dishEditor.en,
    ...userEditor.en
  },
  vi: {
    ...vi,
    ...dishEditor.vi,
    ...userEditor.vi
  }
};
